import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const LinkedConversationIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M6 13.2H4.8L2.25 15.75V4.275C2.25 3.57375 2.82375 3 3.525 3H13.725C14.4262 3 15 3.57375 15 4.275V7.9875H13.725V4.275H3.525V11.925H6V13.2Z" />
    <path d="M7.7475 12C7.7475 10.974 8.47725 10.14 9.375 10.14H11.475V9H9.375C7.926 9 6.75 10.344 6.75 12C6.75 13.656 7.926 15 9.375 15H11.475V13.86H9.375C8.47725 13.86 7.7475 13.026 7.7475 12ZM9.9 12.6H14.1V11.4H9.9V12.6ZM14.625 9H12.525V10.14H14.625C15.5227 10.14 16.2525 10.974 16.2525 12C16.2525 13.026 15.5227 13.86 14.625 13.86H12.525V15H14.625C16.074 15 17.25 13.656 17.25 12C17.25 10.344 16.074 9 14.625 9Z" />
  </Icon>
);

export default memo(LinkedConversationIcon);
